export const SERVER_READY_STATUSES = new Set([
  "SERVER_AGENT_MATCH_SETUP_DONE",
  "WAITING_FOR_PLAYERS",
  "ALL_PLAYERS_JOINED",
  "STARTED",
]);

export function canShowMatchServerIp({ serverIp, status, isFinished, viewerParticipated }) {
  if (!serverIp) return false;
  if (!viewerParticipated) return false;
  if (isFinished) return false;
  return SERVER_READY_STATUSES.has(status);
}
